import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[control-inactive]'
})
export class ControlInactiveDirective {

@Input('control-inactive') inactive: boolean;

  constructor(private el: ElementRef) {

  }

  ngOnChanges(): void {
    if (this.inactive) {
      this.el.nativeElement.style.pointerEvents  = 'none';
      return;
    }

    this.el.nativeElement.style.removeProperty('pointerEvents');
  }
}
